import { theme } from '@/styles/theme';
import { CSSProperties, PropsWithChildren } from 'react';

export type HeaderProps = PropsWithChildren<{
  $color: 'accent' | 'neutral';
  $variant: 'translucent' | 'solid';
  $style?: CSSProperties;
}>;

export default function Header(props: HeaderProps) {
  const { children, $color, $variant, $style = undefined } = props;
  function getCorFundo() {
    if ($variant === 'translucent' && $color === 'accent')
      return theme.panel.translucent_2;
    return theme.colors[$color][$color][4];
  }

  return (
    <nav
      ref={() => {}}
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing[4],
        paddingBottom: theme.spacing[4],
        // paddingRight: theme.spacing[4],
        // paddingLeft: theme.spacing[4],
        gap: theme.spacing[2],
        backgroundColor: getCorFundo(),
        zIndex: 995,
        ...$style,
      }}
    >
      {children}
    </nav>
  );
}
